<template>
  <div class="Page SchematicChart">
    <div class="Page-Content floorplan-row" >

    <div class="building-tab-bar">
      <div style="font-size: 1.8rem;font-weight: 600;">Schematic Chart</div>
      <div v-for="(floorplan, i) in FloorplanData" :key="i" style="margin: 10px 0;">
        <div :style="`color:#fff;padding: 2px;background-color:${floorplan.color}`">{{ i }}</div>
        <!-- <span>{{ floorplan.name }}</span>  -->
        <p style="margin: 2px 0;">{{ floorplan.type }}</p>
      </div>
      <!-- <div class="col" style="width: calc(100% - 10px);height: 65vh;overflow: auto; justify-content: flex-start;padding-right: 10px;">
        <div class="building-btn-group" 
        @click="select_ck_index = i" 
        v-for="(data,i) in select_data" 
        :key="i">
          <div style="background-color: black;height: 2px;width: 100%;"></div>
          <div class="btns row" style="justify-content: space-between;font-weight: 600;" @click="select_data[i].isShow = !select_data[i].isShow">
            <span style="max-width: 90%;">{{data.tabName}}</span>
            <div v-if="data.isShow" class="select-btns" ></div>
            <div v-else class="select-btns" style="background-color: white;border: 1px solid #000;"></div>

          </div>
          <div v-if="data.isShow">
            <div class="btn-info-line row" 
              v-for="(types,j) in data.tabData" 
              :key="j"
              :class="{'click-min-btn':select_data_ck[i] === types}"
              @click="filtrateUnit(types,i)"
              style="justify-content: flex-start;justify-content: space-between;"
              >
              <div>{{ types }}</div>
              <div v-if="types == select_data_ck[i]" class="clear-min" @click="select_data_ck[i] = '',filtrateUnit()" >Clear</div>

            </div>
          </div>
          </div>
          
          <div v-for="(data,i1) in select_data2" :key="i1" class="building-btn-group" >
            <div style="background-color: black;height: 2px;width: 100%;"></div>
            <div class="btns row" style="justify-content: space-between;font-weight: 600;"
              @click="filtrateUnit(i1,i1)"
              :class="{'click-min-btn':select_data_ck[i1]}"
              >
                {{data.tabName}}
              <div class="clear-min" @click="select_data_ck[i1] = '',filtrateUnit()" v-if="select_data_ck[i1]">Clear</div>

              </div>
          </div>
      </div> -->
    </div>

    <div v-if="showfloorplan == 'building'" class="BuildingData">
      <div class="BuildingShowDiv growFromScaleAnimation"  v-for="(building, a) in BuildingList" :key="a">
        <div style="margin-bottom: 1rem;font-weight: 600;text-align: end;width: 100%;">{{ building.title }}</div>
        <div class="table-data">
          <div
            class="table-tr"
            v-for="(data, tr) in building.buildingData"
            :key="tr"
            :class="{ mergetr: data.length == 2 }"
          >
            <div
              class="table-td"
              :style="`background-color:${tddata.color};`"
              :class="{'r2': tddata.r,'td-tab': td == 0,'td-tab-top': td != 0 && tr == 0, mergetd: td == 1 && data.length == 2}"
              @click="goUnit(tddata.unitname)"
              v-for="(tddata, td) in data"
              :key="td"
              v-if="tddata.show || tddata.type == 'tab' || tddata.type == 'Stacks'"
            >
              <span v-if="tr !=0 && td == 0">{{ tddata.name }}</span>
              <span v-else-if="tr == 0 && td != 0">{{ tddata.name }}</span>
              <span v-else-if="tr == 0 && td == 0">{{ tddata.name }}</span>
              <span v-else >{{ tddata.name }}</span>
            </div>
            <div v-else class="table-td"
            :class="{'td-tab': td == 0,'td-tab-top': td != 0 && tr == 0, mergetd: td == 1 && data.length == 2}"
            ></div>
          </div>
        </div>
      </div>
      <!-- <div class="BuildingList flex-contents">
        <div
          class="BuildingListBtn"
          @click="clickBuilding(item, i)"
          :class="{ checkedBuildingBtn: buildingName == i }"
          v-for="(item, i) in BuildingList"
          :key="i"
        >
          {{ i }}
        </div>
      </div> -->
    </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      nowUnit:{},
      // nowBuilding: [], // 当前楼栋数据
      buildingName: "6C", // 当前楼栋名称
      showfloorplan:"building", // 当前所在模块
      // 楼栋列表
      BuildingList: this.$Datas.building,
      // 户型列表
      FloorplanData:this.$Datas.floorplan,
      UnitTypeLists:this.$Datas.unit_type_list,
      
    };
  },
  methods: {
    goUnit(item) {
      console.log(item);
      if (!item) return;
      // this.nowUnit = this.FloorplanData[item]
      this.$router
        .push({
          path: '/Unit',
          query: {
            unit: item,
          },
        })
        .catch((err) => {});
    },

  },
  mounted() {
  },
};
</script>

<style lang="less">

.floorplan-row {
  display: flex;
  flex-direction: row;
}

.clear-min{
  font-weight: 600;
  margin-left: 10px;
  color: brown;
  background-color: white;
  padding: 2px 5px;
  pointer-events: all;
  font-size: 10px;
  border-radius: 10px;
  text-decoration: none !important; 
}


.click-min-btn{
  text-decoration: underline; /* 添加下滑线 */
  position: relative;
  // background-color: #000;
  // color: #fff;
  // border-radius: 5px;
  // padding: 5px;  
  font-size: 1rem !important;
  font-weight: 600;
  // padding-bottom: 5px;
}

// .click-min-btn::before{
//   content: "";
//   position: absolute;
//   width: 50%;
//   height: 2px;
//   background-color: #000;
//   bottom: -5px;
//   margin-bottom: 5px;
// }

// .select-btns{
//   width: 40px;
//   height: 2px;
//   // background-color: black;
//   // border: 1px solid #fff;
//   background-color: black;
//   // border: 1px solid #fff;
//   border-radius: 10px;
// }


.building-tab-bar{
    width: calc(20% - 40px);
    padding: 20px;
    text-align: start;
    height: calc(100% - 40px);
    cursor: pointer;
    .building-btn-group{
      width: 100%;
      border-radius: 5px;
      text-align: start;
      
    }
    .btns{
      margin: 5px 0;
      font-size: 16px;
    }
    .btn-info-line{
      margin-bottom: 2px;
      font-size: 14px;
    }
  }

.SchematicChart {
  overflow: hidden;
  // background-color: #afb2b0 !important;
  .BuildingData {
    width: 80%;
    height: 100%;
    -webkit-overflow-scrolling: touch;
    display: flex;
    justify-content: space-evenly;
  }
  .BuildingShowDiv {
    // position: absolute;
    width: auto;
    height: calc(100% - 2vh);
    // height: 85%;
    margin: 0 20px;
    // margin-bottom: 5vh;
    margin-top: 2vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

  }
}
.mergetr {
  position: relative;
  width: 100%;
}
.mergetd {
  // position: absolute;
  width: calc(100% - 65px) !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  border: 0 !important;
  border-bottom: 1px solid #707070 !important;

  // margin: auto;
}
.table-data {
  border-collapse: collapse;
  border-spacing: 0;
  // border: 1px solid #80808054;
  font-family: QuicksandBook;
  // width: 99%;
  color: #fff;

  // margin-top: 3rem;
  // margin-bottom: 2.5rem;
  display: table;
}
.table-tr {
  // border: 1px solid #9E9E9E;
  display: flex;
  flex-direction: row;
  // width: 99%;
}
.td-tab {
  // width: 1.5rem !important;
  // border: 0 !important;
  border: 1px solid #707070 !important;
  // font-weight: 600 !important;
  // font-size: 14px !important;
  // background-color: #000 !important;
}
.td-tab-top{
  // font-weight: 600 !important;
  // font-size: 14px !important;
  border:  1px solid #707070 !important;
  // background-color: white !important;
}

.table-td:hover {
  color: #ffffff !important;
  background-color: #616161 !important;
}
.r2{
  width: calc(10vw + 10px) !important;
}
.table-td {
  cursor: pointer;
  // border-bottom: 1px solid #000000;
  font-size: 12px;
  // font-weight: 400 !important;
  text-align: center;
  width: 5vw;
  // border: 1px solid #9E9E9E;
  border-width: 0 0 0 1px;
  margin: 0;
  overflow: visible;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1.5rem;
  border-collapse: collapse;
  // background-color: #0000;
  border: 1px solid #707070;
  margin: -1px;
}

.checkedBuildingBtn {
  // color: #2efffa !important;
  color: #000000 !important;
  background-color: white !important;
}

@media screen and (max-height: 500px){
  .SchematicChart .BuildingData{
    height: 100% !important;
  }
}
@media screen and (max-width:800px) {
  .floorplan-row{
    display: flex;
    flex-direction: column ;
    align-items: center;
    justify-content: normal;
    width: 100%;
    height: auto;
    overflow: hidden;
  }
  .building-tab-bar {
    width: 80%;
  }
  .BuildingData {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 20px;
  }
  .table-td{
    width: 15vw;
  }
  .r2 {
    width: calc(30vw + 10px) !important;
  }
}

</style>

